import React from "react"
import "./button.scss"

const Button = props => {
  const { className, title, onClick, disabled = false, type } = props
  const propsBtn = {
    className: "f-btn " + className,
    onClick,
    disabled,
  }
  if (type) {
    propsBtn.type = type
  }
  return (
    <button {...propsBtn}>
      <span className="f-btn--title">{title}</span>
    </button>
  )
}

export default Button
